import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
    formSaveAndRedirect,
    formFinderSaveAndRedirect,
    formDiscardChanges,
    formFinderDiscardChanges,
} from '../actions';
import UnsavedDialog from './UnsavedDialog';

const mapDispatchToProps = (dispatch) => ({
    onSaveAndRedirect: (parent, callBack) => {
        if (parent === 'form') {
            dispatch(formSaveAndRedirect({ callBack }));
        } else if (parent === 'formFinder') {
            dispatch(formFinderSaveAndRedirect({ callBack }));
        }
    },
    onDiscardChanges: (parent) => {
        if (parent === 'form') {
            dispatch(formDiscardChanges());
        } else if (parent === 'formFinder') {
            dispatch(formFinderDiscardChanges());
        }
    },
});

export default withRouter(connect(null, mapDispatchToProps)(UnsavedDialog));
